import React, { Component } from "react";
import $ from 'jquery';

class CompleteSession extends Component {
  
  constructor(props) {
		super(props);
		this.state={
			isSessionEnded: false
		}
	}
 
	componentDidMount(){
		if ( $('#session_time').text() == 'Class Ended' || $("#time_over").is(":visible") )
			{
				this.setState({isSessionEnded: true});
			}
	}
	
	
	render() {
		return (
			<div className="stream_pop_holder">
				<div className="stream_inner_pop inner_host_back">
					<div className="stream_pop_text">Are you sure you want to complete {this.props.sessionName} class?</div>
					<div className="stream_btns_holder">
						<div className="stream_cancel_btn" onClick={() => this.props.updateStateFromChild({openLeave: false})}>Cancel</div>
						{ !this.state.isSessionEnded &&
							<div className="stream_confirm_btn mr20" id="rejoin">Rejoin</div>
						}
						<div className="stream_confirm_btn" id="complete_session">Complete</div>
					</div>
				</div>
			</div>		
	)}
}
export default CompleteSession;
